<template>
  <div>
    <Header></Header>
    <div class="banner">
      <div class="word">
        <div class="wordtitle">
          建设指导
        </div>
        <div class="smallitle">
          ——
        </div>
      </div>
    </div>
    <div class="secondLevel" :class="'item' + index" v-for="(item, index) in pagaData" :key="index">
      <div>
        <div style="width: 519px;">
          <div class="leftContent">
            <img :src="serverUrl + item.logo" width="58px" height="52px">
            <span class="ejjd">{{item.title}}</span>
          </div>
          <div style="width: 519px;height: 1px;background: #000000;opacity: 0.1;margin: 60px 0;"></div>
          <div class="text" v-for="(i, j) in item.array" :key="j">
            <img src="../../assets/images/circular@2x.png" width="12px" height="12px">
            <div>{{i}}</div>
          </div>
        </div>
        <img :src="serverUrl + item.image" width="500px">
      </div>
    </div>
    <!-- <div class="enterprise">
      <div>
        <div style="width: 519px;">
          <div class="leftContent">
            <img src="../../assets/images/qiye@2x.png" width="58px" height="52px">
            <span class="qyjd">企业节点</span>
          </div>
          <div style="width: 519px;height: 1px;background: #000000;opacity: 0.1;margin: 60px 0;"></div>
          <div class="text">
            <img src="../../assets/images/circular@2x.png" width="12px" height="12px">
            <div>
              企业节点属于企业信息系统，不仅要与二级节点对接，还要与企业内部系统对接，同时需要遵从企业相关规定以及二级节点的编码规范、技术标准、管理规范，运营规范等管理体系要求。由于企业规模、大小不同，企业可以根据自己的需求在标识注册、解析等功能基础上，建立企业自身管理方式和应用服务。
            </div>
          </div>
        </div>
        <img src="../../assets/images/jsbottom@2x.png" width="500px">
      </div>
    </div> -->
    <Contact />
    <Footer />
  </div>
</template>

<script>
  import Header from '@/components/Header.vue'
  import Footer from '@/components/Footer.vue'
  import Contact from './Contact.vue'
  import {
    serverUrl
  } from '@/utils/server.js'
  import {
    contentByType
  } from '@/api/api'
  export default {
    data() {
      return {
        pagaData: [],
        serverUrl: serverUrl.baseURL
      }
    },
    components: {
      Header,
      Footer,
      Contact
    },
    mounted() {
      this.getContentByType()
    },
    methods: {
      getContentByType() {
        contentByType({
          type: 2
        }).then(res => {
          this.pagaData = res.data
        })
      }
    }
  }
</script>

<style scoped>
  .banner {
    width: 100%;
    height: 480px;
    background: url(../../assets/images/jsbanner@2x.png) top center no-repeat;
    background-size: cover;
    display: flex;
    align-items: center;
  }

  .secondLevel>div,
  .enterprise>div {
    width: 1300px;
    height: 480px;
    box-sizing: border-box;
    overflow: hidden;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .item1 {
    background-color: #FAFCFF;
  }

  .ejjd,
  .qyjd {
    font-size: 48px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #333333;
    margin-left: 40px;
  }

  .leftContent {
    display: flex;
    align-items: center;
  }

  .text {
    font-size: 18px;
    font-family: Source Han Sans CN;
    font-weight: 300;
    color: #7D889B;
    line-height: 36px;
    display: flex;
    justify-content: flex-start;
    align-items: baseline;
  }

  .text img {
    margin-right: 10px;
  }

  .word {
    width: 1300px;
    margin: 0 auto;
  }

  .smallitle {
    font-size: 16px;
    font-family: Adobe Heiti Std;
    color: #FFFFFF;
    line-height: 46px;
  }

  .wordtitle {
    font-size: 42px;
    font-family: Source Han Sans CN;
    color: #FFFFFF;
    line-height: 46px;
  }
</style>



// WEBPACK FOOTER //
// src/views/node/Guidance.vue